export default function WhatStandOut() {
  return (
    <div>
      <p className="mx-4 mt-4 mb-14 text-center text-3xl font-bold text-[#4e4e4e] lg:mt-32">
        What makes Vitae Stand Out?
      </p>
      <div className="mx-10 flex flex-wrap items-center justify-center">
        <StandOutCard
          title1="Zero Cost for Everyone:"
          title2="It’s Totally FREE!  "
          desc="Vitae3 is built on Polygon and we cover all gas fee, including create, send and claim."
        />
        <div className="flex flex-wrap items-center justify-center">
          <StandOutCard
            title1="Structured Vitae:"
            title2="Manage and Know Org Well"
            desc="Know org‘s identity system and event history through their Vitae Space."
          />
          <StandOutCard
            title1="Independent Contract:"
            title2="Gain Your Ownership"
            desc="Your independent contract carries all your Vitaes and allows you have more scalability."
          />
        </div>
      </div>
    </div>
  );
}

interface Props {
  title1: string;
  title2: string;
  desc: string;
}

function StandOutCard(props: Props) {
  return (
    <div
      className="max-px-28 m-10 my-6 min-w-[340px] max-w-[600px] border-collapse justify-center"
      style={{
        border: 'solid 3px transparent',
        borderRadius: 62,
        backgroundImage:
          'linear-gradient(#fff, #fff), linear-gradient(90deg, rgba(173, 255, 0, 1), rgba(94.61, 255, 101.68, 1))',
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box'
      }}
    >
      <div className="my-20 mx-8">
        <p className="text-center text-2xl font-bold text-[#4e4e4e]">
          {props.title1}
        </p>
        <p className="text-center text-2xl font-bold text-[#7ce7b5]">
          {props.title2}
        </p>
        <div className="gray-200 h-[2px] w-4/5"></div>
        <div className="w-full text-center">
          <p className="text-center text-lg text-[#4e4e4e] sm:mx-10">
            {props.desc}
          </p>
        </div>
      </div>
    </div>
  );
}
